import React from 'react';

const VerifiedIcon = () =>
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5896 2.49984C10.8594 2.49984 8.76785 1.71982 6.99919 0C5.23072 1.71982 3.13924 2.49984 0.409309 2.49984C0.409309 6.9786 -0.517435 13.3944 6.99915 16C14.5163 13.3944 13.5896 6.97865 13.5896 2.49984ZM6.45326 10.3812L4.25772 8.18537L5.24075 7.20239L6.45326 8.41518L8.75787 6.11053L9.74085 7.09351L6.45326 10.3812Z"
      fill="#6CBE00"
    />
  </svg>;

export default VerifiedIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/VerifiedIcon.js